import { map } from 'lodash/fp';
import { UserListDto } from '../../../../types/UserDtos';
import api from '../../../api';
import { withData } from '../../hoc/withData';
import Avatar from '../Avatar';
import LoadingBar from '../LoadingBar';
import MailTo from '../MailTo';
import styles from './style.m.less';

interface OuterProps {
    filterFn?: (user: UserListDto) => boolean;
    includeAssistants?: boolean;
}
interface InnerProps {
    hrs: UserListDto[];
}

function HrList({ hrs }: InnerProps) {
    return (
        <div className={styles.container}>
            {map(
                user => (
                    <div key={user.id} className={styles.user}>
                        <Avatar user={user} size="XL" className={styles.avatar} />
                        <div>
                            <div className={styles.nameAndRoleContainer}>
                                <span className={styles.name}>{user.name}</span>
                                <span className={styles.role}>{user.isHR ? 'HR Admin' : 'HR Assistant'}</span>
                            </div>
                            <div className={styles.mail}>
                                <MailTo href={user.email}>{user.email}</MailTo>
                            </div>
                        </div>
                    </div>
                ),
                hrs
            )}
        </div>
    );
}

export default withData<InnerProps, OuterProps>({
    resolve: {
        hrs: ({ includeAssistants = false, filterFn = () => true }) => {
            return api.usersHR.getAllActiveHrs(includeAssistants).then(users => users.filter(filterFn));
        },
    },
    pendingComponent: () => <LoadingBar />,
})(HrList);
